<template>
  <div>
    <ContractorContactTable type="phone" />
    <ContractorContactTable type="email" />
  </div>
</template>

<script lang="ts">
import ContractorContactTable from '@/pages/contractor/single/components/ContractorContactTable.vue'

export default {
  name: 'ContractorContactsTab',
  components: { ContractorContactTable },
}
</script>
